import StarRatingsTemplate from '../../templates/StarViewTemplate.html';

export default class StarView extends Backbone.View {
    template = StarRatingsTemplate;

    constructor({index, isFilled = false, globalRating, rid}) {
        super(...arguments);

        this.index = index;
        this.isFilled = isFilled;
        this.isHalfFilled = false;
        this.label = window.html('starRating.userRatedLabel', {currentRating: this.index});
        this.globalRating = globalRating;
        this.rid = rid;
        this.$el.addClass('star-container');
    }

    events() {
        return {
            'change': 'onSelected',
            'mouseover .icon-star': 'onHover',
            'click .icon-star': 'onSelected',
            'focusin .noRate' : 'pseudoFocus',
            'focusout .noRate' : 'pseudoFocus'
        };
    }

    setFilled(isFilled, halfFilled = false) {
        if (halfFilled){
            this.$el.find('.icon-star').removeClass('filled');
            this.isFilled = false;

            this.isHalfFilled = isFilled;
            this.$el.find('.icon-star').toggleClass('halfFilled', isFilled);
        } else {
            this.$el.find('.icon-star').removeClass('halfFilled');
            this.isHalfFilled = false;
            
            this.isFilled = isFilled;
            this.$el.find('.icon-star').toggleClass('filled', isFilled);
        }
    }

    onSelected() {
        this.trigger('rate', this.index);
        return false;
    }

    onHover() {
        this.trigger('hover', this.index);
    }

    //Used for the 0th 'no rating' star. When focused, make the container appear to have focus
    pseudoFocus() {
        this.$el.parent().toggleClass('pseudoFocus');
    }

    render() {
        if (this.index > 0) {
            this.$el.empty().append(this.template(this));
        }
        else {
            let noRateTemplate =
                `<input id='noRate-${this.rid}' class='starRadio noRate' type='radio' value='0' name='${this.rid}' aria-label='${window.html('starRating.ratedLabel', {rating: this.globalRating})}'/>`;
            this.$el.empty().append(noRateTemplate);
        }
    }
}
